export default __webpack_public_path__ + "static/media/day-2.a602a1d0.jpg";